import { create } from "zustand";
//#region src/modules/core/hooks/use-current-product-store.ts
var useCurrentProductStore = create((set) => ({
	currentProduct: "",
	setCurrentProduct: (currentProduct) => set({ currentProduct })
}));
//#endregion
export { useCurrentProductStore };
